import React, { useEffect, useRef, useState } from 'react'
import logo from '../Images/logo-main-black.png'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { Link, useNavigate } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert'

//firebase
import {db} from '../firebase';
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { collection, query, getDocs, where } from "firebase/firestore";

//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faEye, faEyeSlash, faLock } from '@fortawesome/free-solid-svg-icons'

//sweetalert
import swal from 'sweetalert';

function Login() {
    const navigate = useNavigate();
    const emailRef = useRef();
    const passwordRef = useRef();
    const videoRef = useRef(null);
    const [showAlert, setShowAlert] = useState(false);
    const [showProgress, setShowProgress] = useState(false);
    const [showSignInbtn, setShowSignInbtn] = useState(true);
    const [therrorMessage, setErrorMessage] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    function SignInUser(event){
        if (event) {
            event.preventDefault();
        }

        const email = emailRef.current.value.trim();
        const password = passwordRef.current.value;
        const auth = getAuth();

        if (!email || !password) {
            setShowAlert(true)
            setErrorMessage("Enter both your instructor email address and password to continue.")
            setShowProgress(false)
            setShowSignInbtn(true)
            return;
        }

        setShowProgress(true);
        setShowAlert(false);
        setShowSignInbtn(false)

        signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
            const userID = userCredential.user.uid

            const q = query(collection(db, "Employees"), where("docId", "==", userID));
            getDocs(q).then((querySnapshot)=>{
                let matchedInstructor = false;

                querySnapshot.forEach((doc)=>{
                    matchedInstructor = true;
                    const userType = doc.data().jobPosition;

                    if (userType === "Instructor" ){
                        navigate("/dashboard")
                    }else{
                        setShowProgress(false)
                        setShowSignInbtn(true)
                        signOut(auth).then(() => {
                            navigate("/")
                            swal("Error", "You are not an instructor. Sign in to your student account on the web.", "warning");
                        }).catch(() => {
                        });
                    }
                })

                if (!matchedInstructor) {
                    setShowProgress(false)
                    setShowSignInbtn(true)
                    signOut(auth).then(() => {
                        navigate("/")
                        swal("Error", "We could not find an instructor account with these details.", "warning");
                    }).catch(() => {
                    });
                }
            })
        })
        .catch((error) => {
            const errorCode = error.code;
            let errorMessage;

            switch (errorCode) {
                case "auth/user-not-found":
                  errorMessage = "No instructor found with this email.";
                  break;
                case "auth/wrong-password":
                  errorMessage = "Incorrect password. Please try again.";
                  break;
                case "auth/invalid-email":
                  errorMessage = "Invalid email address. Please check and try again.";
                  break;
                default:
                  errorMessage = "An error occurred. Please try again.";
            }

            setShowAlert(true)
            setErrorMessage(errorMessage)
            setShowProgress(false)
            setShowSignInbtn(true)
        });
    }

    useEffect(() => {
        if (videoRef.current) {
          videoRef.current
            .play()
            .catch(error => console.error("Autoplay blocked:", error));
        }
    }, []);

  return (
    <div className='d-flex loginContainer'>
        <div className='loginLeft'>
        <video
          ref={videoRef}
          src="https://res.cloudinary.com/ubunifu/video/upload/v1733952785/6860421-uhd_2160_3840_25fps_me7nrs.mp4"
          muted
          autoPlay
          loop
          playsInline
        ></video>
      </div>

        <div className='loginRight'>
            <Link to="/"><img src={logo} alt="Ubunifu" className='loginLogo' /></Link>
            <span className='authEyebrow'>Ubunifu Instructor Platform</span>
            <h5 className='welTxt'>Welcome back!</h5>
            <h6>Sign in with your instructor email address and password to access the platform.</h6>

            <Form onSubmit={SignInUser} className='authFormShell'>
            <Form.Label className="inputLabel">Instructor Email</Form.Label>
            <InputGroup className="mb-3 loginInputGroup">
            <InputGroup.Text id="login-email-addon" className="loginInputAddon">
                <FontAwesomeIcon icon={faEnvelope} className="theLoginIcon"/>
            </InputGroup.Text>
                    <Form.Control
                    placeholder="Enter your instructor email"
                    aria-label="Enter your instructor email"
                    type="email"
                    aria-describedby="login-email-addon"
                    className='loginForm'
                    ref={emailRef}
                    autoComplete="email"
                    spellCheck={false}
                    autoFocus
                    />
            </InputGroup>

            <Form.Label className="inputLabel">Password</Form.Label>
            <InputGroup className="mb-3 loginInputGroup">
            <InputGroup.Text id="login-password-addon" className="loginInputAddon">
                <FontAwesomeIcon icon={faLock} className="theLoginIcon"/>
            </InputGroup.Text>
                    <Form.Control
                    placeholder="Enter your password"
                    aria-label="Enter your password"
                    type={showPassword ? "text" : "password"}
                    aria-describedby="login-password-addon"
                    className='loginForm'
                    ref={passwordRef}
                    autoComplete="current-password"
                    />
            <InputGroup.Text className="passwordToggle">
                <button
                    type="button"
                    className="passwordToggleBtn"
                    aria-label={showPassword ? "Hide password" : "Show password"}
                    aria-pressed={showPassword}
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={() => setShowPassword((prev) => !prev)}
                >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} className="theLoginIcon"/>
                </button>
            </InputGroup.Text>
            </InputGroup>

            {showAlert &&
                <Alert variant={'danger'}>
                    {therrorMessage}
                </Alert>
            }

            <div className='authMetaRow authMetaRowSingle'>
                <p className="text-muted mb-0"><Link to="/forgot-password" className='fgPassLink text-muted'>Forgot Password?</Link></p>
            </div>

            {showSignInbtn &&
                <button type="submit" className='signInbtnn authActionBtn'>
                    Sign In
                </button>
            }

            {showProgress &&
                <Button variant="primary" disabled className='signInbtnnLoading authActionBtn'>
                    <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    />
                    <span> Logging in...</span>
                </Button>
            }
            </Form>
        </div>
    </div>
  )
}

export default Login
